export default __webpack_public_path__ + "846113674ddfcba25167bcb3d7658416.svg";